import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner-layout',
  templateUrl: './spinner-layout.component.html',
  styleUrls: ['./spinner-layout.component.scss']
})
export class SpinnerLayoutComponent {

  constructor() { }


}
